export default "__VITE_ASSET__C3hjxs5y__"